module.exports = __webpack_public_path__ + "static/america-87d855e76d0c50b45f6caa4dc926fdb1.jpg";